import React from 'react';
import { H1, MainBody } from 'shared/components';
import { Spacer } from 'shared/layout';

const TextContent = ({ Heading, Text, theme }) => (
	<div>
		{!!Heading && (
			<>
				<H1
					word-break={{ base: 'break-word', md: 'unset' }}
					as="h2"
					color={theme.color[3]}
				>
					{Heading}
				</H1>
				<Spacer spacing={{ base: 2, md: 4 }} />
			</>
		)}

		{!!Text && (
			<>
				<MainBody as="p" color={theme.color[3]}>
					{Text}
				</MainBody>
				<Spacer spacing={{ base: 4, lg: 8 }} />
			</>
		)}
	</div>
);

export default TextContent;
